import {DialogTypes} from 'common/names';
import {InputDialogData} from 'components/dialogs/InputDialog';
import {NameFormType} from 'components/dialogs/NameDialog';
import {ICloseSubDialogAction} from 'features/layout/redux/actions';
import {call} from 'redux-saga/effects';
import {openDialogWithResult} from 'redux/common/saga/openDialogWithResult';

export function* getName(title: string, label: string, value?: string) {
   const passwordObj: ICloseSubDialogAction<NameFormType> = yield call(openDialogWithResult, {
      id: DialogTypes.InputDialog.id,
      data: {
         title,
         label,
         value,
      } as InputDialogData,
   });

   return passwordObj.payload?.data?.name;
}
